/**
 * aggregator.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { AggregatorDescriptor } from "./aggregator-descriptor";
import { Variable } from "./typed-parameter";

export enum AggregatorResponseType
{
    Standard,
    Frequency,
    SubjectContext
}

export class Aggregator implements AggregatorDescriptor
{
    constructor (
        public name : string,
        public description : string,
        public requiresStateVariable : boolean = false,
        public responseType : AggregatorResponseType
            = AggregatorResponseType.Standard
    )
    {
        //
    }

    public restrictedByAlgorithm : boolean = false;
    public algorithms : string[] = [];

    public childCounter : number = 0;

    public get providesSubjectContext () : boolean
    {
        return this.responseType === AggregatorResponseType.SubjectContext;
    }
    public get isFrequency () : boolean
    {
        return this.responseType === AggregatorResponseType.Frequency;
    }
    public get reportMessageTag () : number
    {
        // The report types happen to line up with the message tags (82, 83, 84)
        // so this is simplest. It's kinda risky code in light of any future
        // protocol changes, but it should be torn out before the next revision!
        return this.responseType + 82;
    }

    public static fromDescriptor (descriptor : AggregatorDescriptor)
        : Aggregator
    {
        const aggregator : Aggregator = new Aggregator(
            descriptor.name,
            descriptor.description,
            descriptor.requiresStateVariable
        );
        if (descriptor.isFrequency)
        {
            aggregator.responseType = AggregatorResponseType.Frequency;
        }
        if (descriptor.providesSubjectContext)
        {
            if (descriptor.isFrequency)
            {
                throw new Error("Descriptor indicated aggregator responds with both frequency and subject context report types!");
            }
            aggregator.responseType = AggregatorResponseType.SubjectContext;
        }

        if (descriptor.algorithms)
        {
            aggregator.restrictedByAlgorithm = true;
            aggregator.algorithms = descriptor.algorithms;
        }

        return aggregator;
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/aggregation/aggregator.ts